// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsColumns {
  display: grid;
  grid-template-columns: 2fr 1fr;
  max-width: 1000px;
  margin: 0 auto;
  grid-gap: 16px;
  align-items: start;
}

.NewsCard {
  width: 100%;
  background-color: var(--light);
  box-shadow: var(--box-shadow);
  border-radius: 8px;
  padding: 48px;
  transition: all 0.2s ease 0s;
}

.NewsCard:hover {
  transform: scale(1.005);
  box-shadow: var(--box-shadow-darker);
}

.NewsCard img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 6px;
}

.NewsCard .twoColumns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 32px;
  margin-bottom: 32px;
}

.NewsPost {
  max-width: 800px;
  margin: 0 auto;
  line-height: 170%;
}

.NewsPost img {
  width: 100%;
  /* max-height: 350px; */
  /* object-fit: contain */
}

.EventCard {
  background-color: var(--light);
  border-radius: 6px;
  box-shadow: var(--box-shadow);
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.EventCard h3 {
  margin: 0;
  margin-bottom: 8px;
}

.scrollToEvents {
  display: none;
}

@media (max-width: 850px) {
  .newsColumns {
    grid-template-columns: 1fr;
  }
  .newsColumns .scrollToEvents {
    display: block;
    margin-bottom: 16px;
  }
  .newsColumns .events h2 {
    margin-top: 8px !important;
  }
}

@media (max-width: 600px) {
  .NewsCard .twoColumns {
    display: grid;
    grid-template-columns: 1fr;
    margin-bottom: 16px;
    grid-gap: 0;
  }
  .NewsCard img {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/News.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".newsColumns {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  max-width: 1000px;\n  margin: 0 auto;\n  grid-gap: 16px;\n  align-items: start;\n}\n\n.NewsCard {\n  width: 100%;\n  background-color: var(--light);\n  box-shadow: var(--box-shadow);\n  border-radius: 8px;\n  padding: 48px;\n  transition: all 0.2s ease 0s;\n}\n\n.NewsCard:hover {\n  transform: scale(1.005);\n  box-shadow: var(--box-shadow-darker);\n}\n\n.NewsCard img {\n  width: 100%;\n  height: 220px;\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n.NewsCard .twoColumns {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 32px;\n  margin-bottom: 32px;\n}\n\n.NewsPost {\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 170%;\n}\n\n.NewsPost img {\n  width: 100%;\n  /* max-height: 350px; */\n  /* object-fit: contain */\n}\n\n.EventCard {\n  background-color: var(--light);\n  border-radius: 6px;\n  box-shadow: var(--box-shadow);\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n}\n\n.EventCard h3 {\n  margin: 0;\n  margin-bottom: 8px;\n}\n\n.scrollToEvents {\n  display: none;\n}\n\n@media (max-width: 850px) {\n  .newsColumns {\n    grid-template-columns: 1fr;\n  }\n  .newsColumns .scrollToEvents {\n    display: block;\n    margin-bottom: 16px;\n  }\n  .newsColumns .events h2 {\n    margin-top: 8px !important;\n  }\n}\n\n@media (max-width: 600px) {\n  .NewsCard .twoColumns {\n    display: grid;\n    grid-template-columns: 1fr;\n    margin-bottom: 16px;\n    grid-gap: 0;\n  }\n  .NewsCard img {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
